<template>
  <svg class="pages-icon" xmlns="http://www.w3.org/2000/svg" width="10.958" height="13.697" viewBox="0 0 10.958 13.697">
    <path data-name="pages-icon" d="M5.37,2A1.368,1.368,0,0,0,4.007,3.37L4,14.327A1.368,1.368,0,0,0,5.363,15.7h8.225a1.374,1.374,0,0,0,1.37-1.37V6.677a1.346,1.346,0,0,0-.4-.966L11.246,2.4A1.346,1.346,0,0,0,10.28,2H5.37Zm4.794,4.109V3.027L13.93,6.794H10.848A.687.687,0,0,1,10.164,6.109Z" transform="translate(-4 -2)" fill="#fff"/>
  </svg>
</template>

<script>
  export default {
    name: 'PagesIcon'
  }
</script>

<style>
  .pages-icon {
    margin-right: 10px;
  }
</style>